const RUNPOD_ENDPOINT_BASE = 'https://api.runpod.ai/v2/ditycoi4c04l4n';

export async function runpodGenerate({ baseImageB64, personImageB64, apiKey }) {
  const key = apiKey || process.env.REACT_APP_RUNPOD_API_KEY;
  
  if (!key) {
    throw new Error('RunPod API key is required. Please provide REACT_APP_RUNPOD_API_KEY in environment variables or pass apiKey parameter.');
  }
  
  console.log('Using RunPod API key:', key ? `${key.substring(0, 10)}...` : 'NOT PROVIDED');
  
  const payload = {
    input: {
      base_image: baseImageB64,
      person_image: personImageB64,
    },
  };

  // 1️⃣ Start job
  const startRes = await fetch(`${RUNPOD_ENDPOINT_BASE}/run`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${key}`,
    },
    body: JSON.stringify(payload),
  });

  if (!startRes.ok) {
    const text = await startRes.text();
    console.error('RunPod API Error Details:', {
      status: startRes.status,
      statusText: startRes.statusText,
      response: text,
      apiKey: key ? `${key.substring(0, 10)}...` : 'NOT PROVIDED'
    });
    throw new Error(`RunPod API error ${startRes.status}: ${text}`);
  }

  const startData = await startRes.json();
  const jobId = startData.id;
  if (!jobId) throw new Error('No job ID returned from RunPod.');

  console.log('Job started:', jobId);

  // 2️⃣ Poll job until completed or failed
  let status = 'IN_QUEUE';
  let result;

  while (status !== 'COMPLETED' && status !== 'FAILED') {
    await new Promise((r) => setTimeout(r, 3000)); // wait 3s between polls

    const statusRes = await fetch(`${RUNPOD_ENDPOINT_BASE}/status/${jobId}`, {
      headers: { 'Authorization': `Bearer ${key}` },
    });

    if (!statusRes.ok) {
      const txt = await statusRes.text();
      throw new Error(`RunPod status error ${statusRes.status}: ${txt}`);
    }

    result = await statusRes.json();
    status = result.status;
    console.log(`Job ${jobId} status:`, status);
  }

  if (status === 'FAILED') {
    console.error('RunPod job failed:', result);
    throw new Error(`RunPod job failed: ${JSON.stringify(result)}`);
  }

  // Handle the new RunPod response format
  let outputB64 = null;
  
  if (result?.output?.image) {
    // New format: output.image is an array
    if (Array.isArray(result.output.image) && result.output.image.length > 0) {
      outputB64 = result.output.image[0];
    } else if (typeof result.output.image === 'string') {
      outputB64 = result.output.image;
    }
  } else if (result?.output && typeof result.output === 'string') {
    // Fallback: output is a string
    outputB64 = result.output;
  }
  
  return { 
    base64: outputB64, 
    raw: result,
    hasImage: !!outputB64 && outputB64.length > 100
  };
}